import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
class GetTradeDataTransactionsUseCase extends UseCase {
  #httpTransactionsRepository

  constructor({httpTransactionsRepository}) {
    super()
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new GetTradeDataTransactionsUseCase({
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({tradeId}) {
    const tradeEntity = TradeEntity.create({
      id: tradeId
    })

    const [error, response] = await this.#httpTransactionsRepository.getTradeData(tradeEntity)

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}

export const factory = GetTradeDataTransactionsUseCase.create
